<template>
  <div class="logistics">
    <div class="tit">
      最新物流资讯
      <div></div>
    </div>
    <div class="list">
      <div class="listAll">
        <dl v-for="(item,index) in logisticsNews" :key="index" @click="setArticle(item)">
          <dt>
            <img :src="item.logo_url" alt="">
          </dt>
          <dd>
            <p>{{ item.title }}</p>
            <p>{{ item.simple_info }}</p>
            <p>发布时间：{{ item.create_time }}</p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Newest',
  props:['logisticsNews'],
  components:{

  },
  data(){
    return {

    }
  },
  computed:{

  },
  methods:{
      setArticle(item){
          this.$emit('toArticle',item)
      }

  },
  created(){

  },
  mounted(){

  }
}
</script>
<style scoped lang="scss">
.logistics {
  width: 1000px;
  margin: 0 auto;
}
.tit {
  font-size: 21px;
  font-weight: 600;
  border-bottom: 1px solid #a6a6a6;
  height: 50px;
  line-height: 50px;
  color: #333333;
  div {
    width: 43px;
    height: 3px;
    background: $bg-color;
  }
}
.list {
  margin-bottom: 100px;
  .listAll {
    display: flex;
    flex-direction: column;
    dl {
      cursor: pointer;
      display: flex;
      margin: 15px 0;
      dt {
        width: 214px;
        height: 135px;
        margin-right: 28px;
        img{
          width: 214px;
          height: 135px;
        }
      }
      dd {
        flex: 1;
        border-bottom: 1px solid #666;
        p {
          font-weight: 700;
          font-size: 14px;
          color: #B3B5B6;
        }
        p:nth-child(1) {
          font-size: 18px;
          color: #242323;
          margin-top:14px;
        }
        p:nth-child(2) {
          margin:15px 0 20px 0;
        }
      }
    }
  }
  >p {
    line-height: 134px;
    text-align: center;
    color:#999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Newest.vue